import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError,map, switchMap } from 'rxjs/operators';

import * as actions from '@redux/actions/singleSignOn';
import * as singleSignOnTypes from '@redux/actions/singleSignOn/singleSignOnTypes';
import { postAsObservable } from '@services/genericService';

import * as config from '../config';

const cpVerifyLoginEpic = (action$) =>
  action$.pipe(
    ofType(singleSignOnTypes.CP_VERIFY_LOGIN),
    switchMap((action) => {
      const params = {
        UserName: action.payload.UserName,
        VerifyCode: action.payload.VerifyCode,
        DeviceId: action.payload.DeviceId,
      };
      
      return postAsObservable(config.ACTION_CP_VERIFY_LOGIN, params).pipe(
        map((res) => {
          if (res.data?.Success) {
            return actions.cpVerifyLoginSuccess({
              ...res.data
            });
          } else {
            return actions.cpVerifyLoginFailed(res.data?.Errors?.[0] || 'Failed');
          }
        }),
        catchError((error) => of(actions.cpVerifyLoginFailed(error.message || 'Failed')))
      );
    })
  );

export default cpVerifyLoginEpic;
